export default "__VITE_ASSET__EcA_aFnc__"